/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 medal3.glb --transform 
Files: medal3.glb [1.97MB] > H:\objects\medal3-transformed.glb [199.83KB] (90%)
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Medal3(props) {
  const { nodes, materials } = useGLTF('3dmodels/medal3-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={[1, 0.038, 1]}>
        <mesh geometry={nodes.Cylinder_1.geometry} material={materials.Awers} />
        <mesh geometry={nodes.Cylinder_2.geometry} material={materials['Awers.001']} />
        <mesh geometry={nodes.Cylinder_3.geometry} material={materials.Bok} />
      </group>
    </group>
  )
}

useGLTF.preload('3dmodels/medal3-transformed.glb')
